<template>
  <div v-if="showMessaging" class="PriceMessage__Container">
    <span
      v-if="categorySavings"
      class="PriceMessage PriceMessage--Category"
      :class="fontSize"
    >
      {{ categorySavings }}
    </span>
    <p
      v-if="bundleSavings"
      class="PriceMessage PriceMessage--Bundle"
      :class="fontSize"
    >
      {{ bundleSavings }}
    </p>
    <p
      v-else-if="excludedFromSavings"
      class="PriceMessage PriceMessage--Swd"
      :class="fontSize"
    >
      {{ excludedFromSavings }}
    </p>
    <p
      v-else-if="lastCall"
      class="PriceMessage PriceMessage--lastCall"
      :class="fontSize"
    >
      {{ lastCall }}
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useProductStore } from '../Product/Composables/Store';

const store = useProductStore();
const props = defineProps({
  item: { type: Object },
  fontSize: { type: String, required: false, default: 'd2' },
  defaultPrice: { type: Number, required: false },
  promo: { type: Object, required: false },
});

const productTags = computed(() => {
  return props?.item?.tags ?? [];
});

// Helper Function
const parseTag = (value) =>
  productTags.value.some((tag) => tag.includes(value));

const noSwdDiscount = () => parseTag('Discount Codes: Deny');
const hasCategory = () => parseTag('Category Promo:');
const isBundle = () => parseTag('Product Bundle');
const isLastCall = () => parseTag('Last Call Assortment');

const showMessaging = computed(() => {
  return props?.defaultPrice != 0;
});

const lastCall = computed(() => {
  // Last Call Messaging with no Active sale aka Customer experience
  if (noSwdDiscount() && isLastCall()) {
    //product is last call, but does not allow discount codes
    const exclusionText =
      props?.item?.exclusionMessaging ||
      store?.terms?.price?.exclusion_messaging;

    return exclusionText;
  }
  return false;
});

const bundleSavings = computed(() => {
  // Do not show if category is enabled
  if (hasCategory()) return false;
  if (noSwdDiscount() && isBundle()) {
    //product bundle is excluded from all discounts, including bundle and SWD
    const exclusionText =
      props?.item?.exclusionMessaging ||
      store?.terms?.price?.exclusion_messaging;
    return exclusionText ?? false;
  }
  return false;
});

const excludedFromSavings = computed(() => {
  // Do not show if category is enabled
  if (hasCategory()) return false;

  if (noSwdDiscount()) {
    //product is not a bundle, and is excluded from SWD discount
    const exclusionText =
      props?.item?.exclusionMessaging ||
      store?.terms?.price?.exclusion_messaging;
    return exclusionText ?? false;
  }
  return false;
});

const categorySavings = computed(() => {
  const promoObj = props?.promo?.category;
  const enabled = hasCategory() && promoObj.enabled;

  if (noSwdDiscount() && enabled) {
    const exclusionMsg = store?.terms?.price?.swd_exclusion_msg;

    return exclusionMsg;
  }
});
</script>
